export default {
  computed: {
    isIos: function () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
  },
}
